import React, { useState } from 'react';
import styled from 'styled-components';
import LabelElement from '../components/molcures/LabelElement';
import Input from '../components/atoms/Input';
import Button from '../components/atoms/Button';
import { useAddLayer, useLayers } from '../hooks/RQuery/utils/layers';
import { layerType } from '../hooks/RQuery/_interface';
import Checkbox from '../components/templates/_old/Checkbox';
import LayerList from 'components/templates/LayerList';

const AdminSt = {
  Wrap: styled.div`
    width: 100%;
    height: 100%;
  `,
  Inner: styled.div`
    padding: 20px;
    display: flex;
  `,
  Area: styled.div``,
};

const Admin = () => {
  const [param, setParam] = useState<{ layerType: layerType; srid: number; isOverwrite: boolean }>({
    layerType: 'CTRL_POINT',
    srid: 5186,
    isOverwrite: true,
  });
  const [file, setFile] = useState(null);
  const addFile = useAddLayer();
  const onChangeFile = (e) => {
    setFile(e.target.files[0]);
  };
  const onChange = (e) => {
    setParam({ ...param, [e.target.name]: e.target.name === 'srid' ? Number(e.target.value) : e.target.value });
  };
  const onChecked = (e) => {
    setParam({ ...param, isOverwrite: e.target.checked });
  };
  const onAdd = () => {
    addFile.mutate(
      { layerType: param.layerType, srid: param.srid, isOverwrite: param.isOverwrite, file },
      {
        onSuccess: () => {
          alert('추가 완료');
        },
        onError: () => {
          alert('추가 실패');
        },
      },
    );
  };
  return (
    <AdminSt.Wrap>
      <AdminSt.Inner>
        <AdminSt.Area>
          <LabelElement label={'타입'} $labelWidth={140}>
            <select onChange={onChange} name={'layerType'} value={param.layerType}>
              <option value={'CTRL_POINT'}>도근점</option>
              <option value={'TRI_POINT'}>삼각점</option>
              <option value={'AUX_TRI_POINT'}>삼각보조점</option>
              <option value={'ETC'}>기타</option>
            </select>
          </LabelElement>
          <LabelElement label={'좌표계'} $labelWidth={140}>
            <select onChange={onChange} name={'srid'} value={param.srid}>
              <option value={5186}>5186</option>
              <option value={5187}>5187</option>
              <option value={5179}>5179</option>
              <option value={5174}>5174</option>
              <option value={4326}>4326</option>
            </select>
          </LabelElement>
          <LabelElement label={'SHP 업로드'} $labelWidth={140}>
            <input type={'file'} onChange={onChangeFile} />
          </LabelElement>
          <LabelElement label={'기존 레이어에 추가'} $labelWidth={140}>
            <input type={'checkbox'} onChange={onChecked} checked={param.isOverwrite} />
          </LabelElement>
          <Button $isGradientBtn={true} text={'추가'} width={120} style={{ marginLeft: 140 }} onClick={onAdd} />
        </AdminSt.Area>
        <AdminSt.Area style={{ flex: 1 }}>
          <LayerList />
        </AdminSt.Area>
      </AdminSt.Inner>
    </AdminSt.Wrap>
  );
};

export default Admin;
